import React, { useRef } from "react";
import { ImagePlus, X } from "lucide-react";
import { toast } from "sonner";

const MAX_MB = 50;

export const MediaPicker = ({ value, onChange, testid = "media" }) => {
  const ref = useRef();
  const pick = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    if (file.size > MAX_MB * 1024 * 1024) {
      toast.error(`File too large (max ${MAX_MB}MB for Telegram)`);
      return;
    }
    onChange(file);
  };
  const url = value ? URL.createObjectURL(value) : null;
  const isVideo = value && value.type.startsWith("video");
  return (
    <div>
      <input ref={ref} type="file" accept="image/*,video/*" onChange={pick} className="hidden" data-testid={`${testid}-input`} />
      {!value ? (
        <button type="button" onClick={() => ref.current?.click()} data-testid={`${testid}-pick`}
          className="w-full border border-dashed border-[color:var(--border-subtle)] rounded-lg py-6 flex flex-col items-center gap-1 text-slate-400 hover:border-gold hover:text-gold transition-colors duration-200">
          <ImagePlus size={22} />
          <span className="text-sm">Add image or video (optional)</span>
          <span className="text-[11px] text-slate-600">max {MAX_MB}MB</span>
        </button>
      ) : (
        <div className="relative border border-[color:var(--border-subtle)] rounded-lg overflow-hidden" data-testid={`${testid}-preview`}>
          {isVideo
            ? <video src={url} controls className="w-full max-h-56 bg-black" />
            : <img src={url} alt="preview" className="w-full max-h-56 object-contain bg-black" />}
          <button type="button" onClick={() => onChange(null)} data-testid={`${testid}-clear`}
            className="absolute top-2 right-2 bg-black/70 text-white rounded-full p-1 hover:bg-red-600">
            <X size={16} />
          </button>
          <div className="px-3 py-1.5 text-[11px] text-slate-400 bg-[#0f1621] truncate">{value.name} · {(value.size / 1024 / 1024).toFixed(1)}MB</div>
        </div>
      )}
    </div>
  );
};
